import { useRef, useState , useEffect } from "react";
import Config from "../../Config";


import gochat from "../../gochat.png";

function QuickChat(props)
{
    const [id, setId] = useState(props.id);
    const [title, setTitle] = useState(props.title);
    const [name, setName] = useState('CHAT');

    if(props.name!=undefined && name!=props.name)
    {
        setName(props.name);
    }

    const openChat = () => {

        props.mainView.openChat(title, "px_group", id);
    }


    return <div>
        <span onClick={openChat}>{name}</span>
    </div>

}


export default QuickChat;